namespace Matrix.Visualizer {
    export enum GraphContextMenuItemType {
        FocusNode = 0,
        WebUrl = 1
    }
    Serenity.Decorators.registerEnumType(GraphContextMenuItemType, 'Matrix.Visualizer.GraphContextMenuItemType');
}
